import type { AdminDashboardJobTrendProps } from "../../models/admin-dashboard.models";
import { getAdminDashboardJobTrendDays } from "../../utils/admin-dashboard.utils";

// Show errors as part of each day's total log volume, with exact figures available to keyboard users.
// Empty daily tracks keep sparse logs from stretching across the chart.
const AdminDashboardJobTrend = ({ dailyCounts }: AdminDashboardJobTrendProps) => {
  const days = getAdminDashboardJobTrendDays(dailyCounts);
  const maxTotal = Math.max(1, ...days.map((day) => day.total));

  return (
    <figure data-test="admin-dashboard-job-trend">
      <figcaption className="mb-3 flex items-center justify-between gap-3 text-xs opacity-60">
        <span>Daily log volume · 14 days</span>
        <span>Errors in red</span>
      </figcaption>
      <div className="flex h-20 items-end gap-1.5" aria-label="Daily job logs">
        {days.map((day) => (
          <div
            key={day.day}
            tabIndex={0}
            role="img"
            aria-label={`${day.day}: ${day.total} logs, ${day.errors} with errors`}
            title={`${day.day}: ${day.total.toLocaleString()} logs, ${day.errors.toLocaleString()} with errors`}
            data-test={`admin-dashboard-job-day-${day.day}`}
            className="flex h-full min-w-0 flex-1 items-end rounded-t-sm bg-[#E9F4F3] focus-visible:outline focus-visible:outline-2 focus-visible:outline-green dark:bg-gray-700"
          >
            <div
              className="relative w-full rounded-t-sm bg-green dark:bg-teal-400"
              style={{ height: `${(day.total / maxTotal) * 100}%` }}
            >
              <div
                className="absolute bottom-0 w-full bg-[#BF0002] dark:bg-red-400"
                style={{ height: `${day.total > 0 ? (day.errors / day.total) * 100 : 0}%` }}
              />
            </div>
          </div>
        ))}
      </div>
      <div className="mt-2 flex justify-between text-[10px] opacity-50" aria-hidden="true">
        <span>{days[0].day.slice(5, 10)}</span>
        <span>{days[days.length - 1].day.slice(5, 10)}</span>
      </div>
    </figure>
  );
};

export default AdminDashboardJobTrend;
